module.exports = __webpack_public_path__ + "media/11.9763d13e.mp3";